/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { DesktopDrawerComponent } from './SummaryDrawer';

const DesktopDrawer = (props) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (mounted && (<DesktopDrawerComponent {...props} />));

};

export default DesktopDrawer;
